<template>
  <div>
    <!-- alerta incidência simultânea que não for para icms st -->
    <Notificacao
      v-if="(classe == 'difal' || classe == 'carga_liquida' || classe == 'antecipacao') && existeSt"
      class="padding-alerta"
      tipo="alerta"
      :texto="textoAlerta"
    />
    <!-- alerta incidência simultânea para icms st -->
    <Notificacao
      v-if="classe == 'icms_st' && (existeAntecipacao || existeDifal || existeCargaLiquida)"
      class="padding-alerta"
      tipo="alerta"
      :texto="textoIncidenciaSt"
    />
  </div>
</template>

<script>
import Notificacao from "@/components/Notificacao/Notificacao.vue";

export default {
  name: "AlertaIncidenciaSimultanea",
  props: {
    classe: String,
    textoAlerta: String,
    existeSt: Boolean,
    existeAntecipacao: Boolean,
    existeCargaLiquida: Boolean,
    existeDifal: Boolean
  },
  components: { Notificacao },
  data() {
    return {
      textoSt: {
        antecipacao:
          "Na hipótese de ocorrer a incidência de Substituição Tributária (ICMS ST), atendidos os critérios da legislação e, desde que observadas suas exceções, desconsiderar o resultado da aba Antecipação Com Encerramento.",
        difal:
          "Na hipótese de ocorrer a incidência de Substituição Tributária (ICMS ST), atendidos os critérios da legislação e, desde que observadas suas exceções, desconsiderar o resultado da aba Diferencial de Alíquotas Contribuinte.",
        cargaLiquida:
          "Atendidos os requisitos de enquadramento da Substituição Tributária (ICMS ST), desconsiderar o resultado da aba Carga Líquida, exceto nos casos em que houver disposição contrária prevista na legislação."
      }
    };
  },
  computed: {
    textoIncidenciaSt() {
      let textoCarga = this.existeCargaLiquida ? this.textoSt.cargaLiquida : "";
      let textoAntec = this.existeAntecipacao
        ? (this.existeCargaLiquida ? "</br></br>" : "") + this.textoSt.antecipacao
        : "";
      let textoDifal = this.existeDifal
        ? (this.existeAntecipacao || this.existeCargaLiquida ? "</br></br>" : "") +
          this.textoSt.difal
        : "";
      let texto = textoCarga + textoAntec + textoDifal;
      return texto;
    }
  }
};
</script>

<style lang="scss" scoped>
.padding-alerta {
  margin-left: 22px;
  margin-top: 0px;
  &:last-child {
    margin-bottom: 0px;
  }
}
</style>
